module.exports = __webpack_public_path__ + "static/KukuFM-6ba7fa190a105dd65c1f94085e57c41d.png";